import {Col, Table} from 'antd';
import {Fragment, useEffect, useState} from 'react';
import TableColumn from './columns';
import {
  INDEX_PAGE_SIZE_DEFAULT,
  INDEX_PAGE_SIZE_OPTIONS,
} from 'src/shared/constants/AppConst';
import {productRejectionReasonsService} from 'src/shared/services/product-rejection-reasons';
import {ProductRejectionReasonsDto} from 'src/shared/services/product-rejection-reasons/dto/product-rejection-reasons-dto';
import {popupConfirm} from 'src/shared/components/popup-confirm';
import {useIntl} from 'react-intl';
import useTableV2 from 'src/shared/hooks/useTableV2';

interface IProductRejectionReasonsTableProps {}

const ProductRejectionReasonsTable = (
  props: IProductRejectionReasonsTableProps,
) => {
  const {messages} = useIntl();
  const {showTotal, ...tableV2} = useTableV2();
  const [productRejectionReasonsList, setProductRejectionReasonsList] =
    useState<ProductRejectionReasonsDto[]>([]);
  const [
    productRejectionReasonsListTotal,
    setProductRejectionReasonsListTotal,
  ] = useState(0);
  const [isTableLoading, setIsTableLoading] = useState(false);

  const [
    isRefreshProductRejectionReasonsList,
    setIsRefreshProductRejectionReasonsList,
  ] = useState(false);
  const [pageSizeOptions] = useState<string[]>(INDEX_PAGE_SIZE_OPTIONS);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: INDEX_PAGE_SIZE_DEFAULT,
  });

  useEffect(() => {
    (async () => {
      try {
        setIsTableLoading(true);
        let productRejectionReasonsAll =
          await productRejectionReasonsService.getproductRejectionReasons({
            Page: pagination.page,
            PageSize: pagination.limit,
          });
        setProductRejectionReasonsList(productRejectionReasonsAll.Data);
        setProductRejectionReasonsListTotal(productRejectionReasonsAll.Total);
      } catch (error) {
        console.error(error);
      } finally {
        setIsTableLoading(false);
      }
    })();
  }, [pagination, isRefreshProductRejectionReasonsList]);

  const tablePagination = {
    total: productRejectionReasonsListTotal,
    pageSizeOptions: pageSizeOptions,
    pageSize: pagination.limit,
    showSizeChanger: true,
    showTotal,
    current: pagination.page,
    onShowSizeChange: async (current: any, PageSize: any) => {
      setPagination({limit: PageSize, page: current});
    },
    onChange: (page: any, pageSize: any) => {
      setPagination({limit: pageSize, page: page});
    },
  };

  const deleteRejectionReason = (record: ProductRejectionReasonsDto) => {
    popupConfirm(async () => {
      try {
        await productRejectionReasonsService.deleteRejectionReason(
          record.Id ?? '',
        );
        setIsRefreshProductRejectionReasonsList(
          !isRefreshProductRejectionReasonsList,
        );
      } catch (error) {
        console.error(error);
      }
    }, `${messages['commom.areYouSureYouWantToDelete'].toString()}` + ' ' + [record.Name] + `?`);
  };

  const changeRejectionReasonStatus = async (id: string) => {
    try {
      await productRejectionReasonsService.changeRejectionReasonStatus(id);
      setIsRefreshProductRejectionReasonsList(
        !isRefreshProductRejectionReasonsList,
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Fragment>
      <Col>
        <Table
          columns={TableColumn(
            deleteRejectionReason,
            changeRejectionReasonStatus,
          )}
          rowKey={(record: ProductRejectionReasonsDto) =>
            record?.Id?.toString()
          }
          dataSource={productRejectionReasonsList}
          pagination={tablePagination}
          bordered={true}
          loading={isTableLoading}
          {...tableV2}
        />
      </Col>
    </Fragment>
  );
};

export default ProductRejectionReasonsTable;
